import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { decodeJWT, fetchAuthSession } from 'aws-amplify/auth';
import { jwtDecode } from 'jwt-decode';
import { from, map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  constructor(private msalService: MsalService) {}

  getIdToken() {
    return localStorage.getItem('azureIdToken');
  }

  getaccessToken() {
    return localStorage.getItem('azureAccessToken');
  }

  getazureId() {
    return localStorage.getItem('azureId');
  }

  getAzureEmail() {
    return localStorage.getItem('azureEmail');
  }

  getAzureUserName() {
    return localStorage.getItem('azureUserName');
  }

  async refreshIdToken() {
    return await fetchAuthSession({ forceRefresh: true });
  }

  getUserRole(): Observable<string> {
    return this.userData().pipe(
      map((res: any) => res.tokens?.idToken?.payload['custom:role'] || '')
    );
  }

  userData() {
    return from(fetchAuthSession());
  }

  login() {
    sessionStorage.clear();
    this.clearLocalStorage();
    this.msalService.loginRedirect();
  }

  areTokensExpired(): boolean {
    const idToken = this.getIdToken();
    const accessToken = this.getaccessToken();

    if (!idToken || !accessToken) {
      return true;
    }

    return this.isTokenExpired(idToken) || this.isTokenExpired(accessToken);
  }

  private isTokenExpired(token: string): boolean {
    try {
      const decodedToken: any = jwtDecode(token);
      const currentTime = Math.floor(Date.now() / 1000);

      return decodedToken.exp <= currentTime;
    } catch (error) {
      return true;
    }
  }

  clearLocalStorage() {
    let lang = localStorage.getItem('Language') || '';
    localStorage.clear();

    localStorage.setItem('Language', lang);
  }
}
